/* Project Unity why-disclosure modal ([data-why-disclosure-modal]). Loaded by the
   why page and the three explainer pages. */
(function () {
  /* Focus restoration lives in project-unity-core.js (loaded by the header).
     Fall back to a plain focus call if that script is missing. */
  function restoreFocus(el) {
    if (window.ProjectUnity && typeof window.ProjectUnity.restoreFocus === 'function') {
      window.ProjectUnity.restoreFocus(el);
      return;
    }
    if (!el) return;
    el.focus({ preventScroll: true });
  }

  document.querySelectorAll('[data-project-unity]').forEach(function (root) {
  if (root.dataset.puWhyDisclosureReady === 'true') return;
  root.dataset.puWhyDisclosureReady = 'true';

  const whyDisclosureModal = root.querySelector('[data-why-disclosure-modal]');
  if (whyDisclosureModal) {
    const whyDisclosurePanel = whyDisclosureModal.querySelector('.pu-why-disclosure-modal__panel');
    const whyDisclosureClose = whyDisclosureModal.querySelector('[data-why-disclosure-close]');
    const whyDisclosureTitle = whyDisclosureModal.querySelector('[data-why-disclosure-title]');
    const whyDisclosureSlot = whyDisclosureModal.querySelector('[data-why-disclosure-slot]');
    let whyDisclosureTrigger = null;
    let whyDisclosureSource = null;
    let whyDisclosureContent = null;
    let whyDisclosureOverflow = '';

    function whyDisclosureFocusable() {
      return Array.prototype.slice.call(whyDisclosurePanel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(function (node) {
        return !node.disabled && node.getAttribute('aria-hidden') !== 'true';
      });
    }

    function setWhyPageInert(value) {
      Array.prototype.forEach.call(root.children, function (child) {
        if (child !== whyDisclosureModal) child.inert = value;
      });
    }

    /* The chat launcher hides while this modal is open. Stylesheets read that from a root
       class: an html:has(.pu-modal.is-open) check re-styled the whole page on every class
       change anywhere (INP). */
    const whyDisclosureHidesLauncher = whyDisclosureModal.matches('.pu-home .pu-modal');

    function closeWhyDisclosure() {
      if (!whyDisclosureModal.classList.contains('is-open')) return;
      whyDisclosureModal.classList.remove('is-open');
      if (whyDisclosureHidesLauncher) document.documentElement.classList.remove('pu-home-modal-open');
      whyDisclosureModal.setAttribute('aria-hidden', 'true');
      setWhyPageInert(false);
      document.documentElement.style.overflow = whyDisclosureOverflow;
      if (whyDisclosureContent && whyDisclosureSource) whyDisclosureSource.appendChild(whyDisclosureContent);
      if (whyDisclosureSource) whyDisclosureSource.hidden = true;
      if (whyDisclosureTrigger) whyDisclosureTrigger.setAttribute('aria-expanded', 'false');
      const returnTarget = whyDisclosureTrigger;
      whyDisclosureTrigger = null;
      whyDisclosureSource = null;
      whyDisclosureContent = null;
      whyDisclosureSlot.replaceChildren();
      restoreFocus(returnTarget);
    }

    function openWhyDisclosure(trigger) {
      const source = root.querySelector('#' + trigger.dataset.whyDisclosureOpen);
      const content = source && source.querySelector('[data-why-disclosure-content]');
      if (!source || !content) return;
      whyDisclosureTrigger = trigger;
      whyDisclosureSource = source;
      whyDisclosureContent = content;
      whyDisclosureTitle.textContent = trigger.dataset.disclosureTitle || '';
      whyDisclosureSlot.appendChild(content);
      source.hidden = true;
      trigger.setAttribute('aria-expanded', 'true');
      whyDisclosureOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      setWhyPageInert(true);
      whyDisclosureModal.classList.add('is-open');
      if (whyDisclosureHidesLauncher) document.documentElement.classList.add('pu-home-modal-open');
      whyDisclosureModal.setAttribute('aria-hidden', 'false');
      whyDisclosureClose.focus({ preventScroll: true });
    }

    root.querySelectorAll('[data-why-disclosure-source]').forEach(function (source) { source.hidden = true; });
    root.querySelectorAll('[data-why-disclosure-action]').forEach(function (action) { action.hidden = false; });
    root.querySelectorAll('[data-why-disclosure-open]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', function () { openWhyDisclosure(trigger); });
    });
    whyDisclosureClose.addEventListener('click', closeWhyDisclosure);
    whyDisclosureModal.addEventListener('click', function (event) { if (event.target === whyDisclosureModal) closeWhyDisclosure(); });
    document.addEventListener('keydown', function (event) {
      if (!whyDisclosureModal.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        closeWhyDisclosure();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = whyDisclosureFocusable();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }
  });
})();
